import UserPreferences from 'uScope/js/extensions/user-config/UserPreferences';
import app from '../../public-api';

/* The user rights store is currently only used by Image Analysis module, which is disabled in the 12.5 build.
import { once } from '../../../../shared/util/functions';
import { UserImageRightsStore } from './UserImageRightsStore';
import Vue from 'vue';

app.plugins.register({
  name: 'us:user-rights-store',

  extends: 'uScope',

  dependencies: ['pi:platform-api'],

  constructor: once(({ dataServer }) => {
    Vue.$store.resources.set('USER_RIGHTS', dataServer.user.userRightsProvider);
    Vue.$store.resources.set('USER_CONFIG', dataServer.user.userConfigProvider);
    Vue.$store.use(UserImageRightsStore);
  })
});
*/

app.plugins.register({
  name: 'us:user-config',

  extends: 'uScope',

  dependencies: [['pi:platform-api', { required: false }]],

  factory (uScope, platformAccess) {
    const service = new UserPreferences(uScope, platformAccess);

    uScope.events.on('uScope:reset', service.reset);

    service.init();
    service.load();

    return service;
  }
});
